import { apiGet, apiPost, mockSuccess } from "@redriver/cinnamon";

const NAMESPACE = "PARENT/DASHBOARD_INFO";

export const ActionTypes = {
  GetDashboardInfo: `${NAMESPACE}/GET_DASHBOARD_INFO`,
};

export const getDashboardInfo = () => {
  return apiGet(ActionTypes.GetDashboardInfo, "resort-reps/dashboard");
};
